import React from 'react';
import './Footer.css';
import instagram from '../Assets/instagram_icon.png';
import pinterest from '../Assets/pintester_icon.png';
import whatsapp from '../Assets/whatsapp_icon.png';
import logo from '../Assets/logo.png';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <img src={logo} alt="Nexus Med Logo" />
                    <h3>Nexus Med</h3>
                    <p>Your trusted medical supply partner</p>
                </div>
                
                <div className="footer-columns">
                    <div className="footer-column">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="/products">Products</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>
                    
                    <div className="footer-column">
                        <h4>Categories</h4>
                        <ul>
                            <li><a href="/medical">Medical Equipment</a></li>
                            <li><a href="/lab">Lab Supplies</a></li>
                            <li><a href="/chemical">Chemicals</a></li>
                            <li><a href="/reagent">Reagents</a></li>
                        </ul>
                    </div>
                    
                    <div className="footer-column">
                        <h4>Connect With Us</h4>
                        <div className="social-icons">
                            <a href="#"><img src={instagram} alt="Instagram" /></a>
                            <a href="#"><img src={pinterest} alt="Pinterest" /></a>
                            <a href="#"><img src={whatsapp} alt="WhatsApp" /></a>
                        </div>
                        <p>support@nexusmed.com</p>
                        <p>+1 (555) 123-4567</p>
                    </div>
                </div>
            </div>
            
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Nexus Med. All rights reserved.</p>
                <div className="legal-links">
                    <a href="/privacy">Privacy Policy</a>
                    <span> | </span>
                    <a href="/terms">Terms of Service</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;